import "../../style/academics.css";

const PhD = () => {
  return (
    <>
      <div className="about ms-2 ms-md-6 ms-lg-5">Doctoral Programmes</div>
      <div className="border-bottom ms-2 ms-md-6 ms-lg-5"></div>
      <div className="text2-UG mx-auto ms-lg-5">
        The university offers doctoral programmes (full-time and part-time both)
        in various discipline.
      </div>
    </>
  );
};

export default PhD;
